var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-0"},[_c('v-row',{staticClass:"pa-0 ma-0",attrs:{"justify":"space-around"}},[_c('v-col',{staticClass:"dark_blue elevation-5 ma-1"},[_c('v-container',{domProps:{"innerHTML":_vm._s(_vm.previewHtml)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }